import React from 'react';
import { RadioGroup, RadioGroupProps as BaseRadioProps } from '@economic/gaudi';
import Field, { FieldProps } from '../Field';

function parseNumber(value: any) {
    return Number(value);
}

const FieldRadioGroup = ({ child: Component, onChange, ...fieldProps }) => (
    <Component {...fieldProps} onChange={event => onChange(event.target.value)} />
);

interface Props extends FieldProps<BaseRadioProps> {}

export function RadioGroupField({ as, fieldClassName, ...props }: Props) {
    const Component = as || RadioGroup;
    return <Field {...props} as={FieldRadioGroup as any} child={Component} fieldClassName={fieldClassName} />;
}

export function NumberRadioGroupField(props: Props) {
    return <RadioGroupField {...props} parse={parseNumber} />;
}
